import { registerPlugin } from '@capacitor/core';

/**
 * A single heuristic that fired, e.g. `su-binary` or `cydia-app`. The native
 * implementations own the vocabulary; the web layer only passes it through.
 */
export type IntegritySignal = string;

export interface DeviceIntegrityResult {
  compromised: boolean;
  signals: IntegritySignal[];
}

export interface DeviceIntegrityPlugin {
  check(): Promise<DeviceIntegrityResult>;
}

/**
 * Root (Android) and jailbreak (iOS) heuristics. There is no browser
 * equivalent, so the web implementation always reports a clean device.
 */
export const DeviceIntegrity = registerPlugin<DeviceIntegrityPlugin>(
  'DeviceIntegrity',
  {
    web: () => ({
      check: async (): Promise<DeviceIntegrityResult> => ({
        compromised: false,
        signals: [],
      }),
    }),
  },
);
